/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationPavillonInformationCitiesQuery from '../graphql/queries/GetSimulationPavillonInformationCitiesQuery.js';

const useGetSimulationPavillonInformationCitiesQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationPavillonInformationCitiesQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationPavillonInformationCities: R.omit(['__typename'], data?.getSimulationPavillonInformationCities_simulation_pavillon_information || {})
  };
};

export default useGetSimulationPavillonInformationCitiesQuery;
